import { apiPut } from '../../generic/Api_Functions'
import SmartMateriaUITable from '../../generic/SmartMateriaUITable'
import { useSmartTranslation } from '../../generic/hooks/useSmartTranslation'
import { systemValueDescription, systemValueLabel } from '../../generic/systemValues/systemValueLabel'
import { useAuthorization } from '../../generic/hooks/useAuthorization'

const OrderStatusTypes = () => {
  const { t_ } = useSmartTranslation()
  const isUserAuthorized = useAuthorization()

  const columns = [
    {
      name: t_('Code'),
      field: 'code',
      edit: false
    },
    {
      name: t_('Name'),
      field: 'name',
      edit: false,
      render: (row) => systemValueLabel(t_, 'order_status_type', row),
      renderOnlyInReadMode: true
    },
    {
      name: t_('Description'),
      field: 'description',
      charLimit: 200,
      render: (row) => systemValueDescription(t_, 'order_status_type', row),
      renderOnlyInReadMode: true
    }
  ]

  const actions = {

    edit: {
      fetchFunction: (row) => {
        return apiPut('orderStatusType', row)
      },
      disabled: !isUserAuthorized('EDIT_ORDER_STATUS_TYPE')
    }
  }

  return (
    <SmartMateriaUITable
      tableTuneUniqueKey='orderStatusType'
      columns={columns}
      title={t_('Order status types')}
      dataFetch='orderStatusType'
      actions={actions}
      pageable
    />
  )
}

export default OrderStatusTypes
